export const BACKEND_URL = "https://galeriakrakowska.treespot.pl" 

export const COFFEE_SHOP_CATEGORY_ID = "3";
export const RESTAURANT_CATEGORY_ID = "18";